import EditTemplate from "../_templates/EditTemplate";
import { teamSchema } from "../../../schemas/team.schema";
import { getTeam, updateTeam } from "../../../api/coredata.api";

export default function EditTeam() {
  return (
    <EditTemplate
      title="Edit Team"
      schema={teamSchema}
      fetchFn={getTeam}
      updateFn={updateTeam}
      redirectPath="/cricket/teams"
    />
  );
}
